import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchEmployers = createAsyncThunk(
  'employers/fetchEmployers',
  async ({ q = '', filter = '', limit = 100 }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=employers-list', { params: { q, filter, limit } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const fetchEmployerDetail = createAsyncThunk(
  'employers/fetchDetail',
  async ({ employerId }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=employers-detail', { params: { employer_id: employerId } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const fetchEmployerJobs = createAsyncThunk(
  'employers/fetchJobs',
  async ({ employerId, filter = 'all' }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=employers-jobs', { params: { employer_id: employerId, filter } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

const employersSlice = createSlice({
  name: 'employers',
  initialState: {
    items: [],
    selectedEmployer: null,
    employerJobs: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedEmployer: (state) => {
      state.selectedEmployer = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchEmployers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchEmployerDetail.fulfilled, (state, action) => {
        state.selectedEmployer = action.payload;
      })
      .addCase(fetchEmployerJobs.fulfilled, (state, action) => {
        state.employerJobs = action.payload;
      });
  },
});

export const { clearError, clearSelectedEmployer } = employersSlice.actions;
export default employersSlice.reducer;
